import reduxKeys from "../../constants/reduxKeys";
import { formatListItems } from "../../utils";

// reducers.js
const initialState = {
  filters: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case reduxKeys.SET_INVENTORY_FILTERS:
      const transferTypes = action.payload?.transferTypes?.filter(item => item?.is_show ?? true);
      const inventoryStates = formatListItems(action.payload.inventoryStates, "inventoryStateId", "inventoryState");
      return { ...state, filters: { ...state.filters, ...action.payload, transferTypes, inventoryStates, allTransferType: action.payload?.transferTypes ?? {} } };
    case reduxKeys.SET_SUPPLIERS:
      const list = formatListItems(action.payload, "supplierId", "supplierName");
      return { ...state, filters: { ...state.filters, suppliers: list } };
    case reduxKeys.SET_WAREHOUSE:
      const wareHouseList = formatListItems(action.payload, "warehouseId", "warehouseName");
      return { ...state, filters: { ...state.filters, warehouse: wareHouseList } };
    case reduxKeys.SET_SOFTWARE_PROVIDER:
      const softwareProviders = formatListItems(action.payload, "providerId", "providerName");
      return { ...state, filters: { ...state.filters, softwareProviders } };
      case reduxKeys.SET_BILLING_COMPANIES:
        const billingCompanies = formatListItems(action.payload, "billingCompanyId", "companyName");
        return { ...state, filters: { ...state.filters, billingCompanies} };
    case reduxKeys.SET_COMPANY_REQUEST_TYPE:
      const requestTypes = formatListItems(action.payload, "requestTypeId", "requestType");
      return { ...state, filters: { ...state.filters, requestTypes } };
      case reduxKeys.SET_USERS_ROLES:
        const userRoles = formatListItems(action.payload, "role_id", "role_name");
        return { ...state, filters: { ...state.filters, userRoles } };
    default:
      return state;
  }
};

export default reducer;